 
import React, { useRef, useState } from 'react';
import { FormControl, InputGroup, Button } from 'react-bootstrap';
import classNames from 'classnames';
import useOnClickOutside from '../hooks/useOnClickOutside';

import './TextSearchComponent.scss';

const SearchComponent = ({ searchValue, setSearchValue = () => {}, placeholder = 'Search...', className }) => {
	const containerRef = useRef(null);
	const [isActive, setIsActive] = useState(false);

	const handleClearBtn = () => {
		setSearchValue('');
		setIsActive(false);
	};

	const handleSearchTerm = (e) => {
		setSearchValue(e.target.value);
	};

	useOnClickOutside(containerRef, () => setIsActive(false), 'mousedown');

	return (
		<section className={classNames('search-component-container', { active: isActive }, className)} ref={containerRef}>
				<InputGroup className="search-professional">
					<InputGroup.Text className="search-icon" onClick={() => setIsActive(true)} />
					<>
						<FormControl
							placeholder={placeholder}
							aria-label={placeholder}
							aria-describedby="clear-button"
							value={searchValue}
							onClick={() => setIsActive(true)}
							onChange={handleSearchTerm}
						/>
						{(searchValue.length > 0 || searchValue?.length > 0) && (
							<Button className="clear-button" id="clear-button" onClick={handleClearBtn}>
								Clear
							</Button>
						)}
					</>
				</InputGroup>
			</section>
	);
};

export default SearchComponent;
